/* eslint-disable react/no-array-index-key */
import { Text, View } from '@react-pdf/renderer';
import { SecurityAdvice as ISecurityAdvice } from '../../../models/pro.model';
import { sanitiseBlock } from '../../../utils/text-formatting.utils';
import styles from '../pro-report-pdf-styles';
import ThreatTable from './pro-report-threat-table';

interface SecurityAdviceProps {
  securityAdvice: ISecurityAdvice | null | undefined;
}

function SecurityAdvice({ securityAdvice }: SecurityAdviceProps) {
  if (!securityAdvice) return null;

  return (
    <View>
      <View wrap={false} style={styles.table}>
        <Text style={styles.tableHeaderFullWidth}>Security advice</Text>
      </View>
      <View wrap={false} style={styles.table}>
        <Text style={styles.tableSubHeaderFullWidth}>
          <Text style={{ fontWeight: 700 }}>Source: </Text>{' '}
          {securityAdvice.source}
        </Text>
      </View>
      <View style={styles.table}>
        <Text style={styles.tableCellFullWidth}>
          <Text style={{ fontWeight: 700 }}>Summary:</Text>
          {'\n'}
          <Text style={{ marginBottom: 6 }}>
            {sanitiseBlock(securityAdvice?.summary, [])}
          </Text>
        </Text>
      </View>
      <View style={styles.hr} />
      <ThreatTable threats={securityAdvice.threats || []} />
      <View style={styles.hr} />
    </View>
  );
}

export default SecurityAdvice;
